<div class="page_container">
  <ui-page-header [title]="'settings.orders' | translate" [lucideIcon]="'ShoppingBag'">
    <!-- The header actions write the orders-settings PATCH, which the alert
         toggles have no part in: a Save on a tab that already applied would lie. -->
    <ui-button
      *ngIf="tab === 'pricing'"
      type="secondary"
      [label]="'settings.restore_defaults' | translate | uppercase"
      icon="refresh-cc"
      iconPosition="start"
      (click)="restoreDefaults()">
    </ui-button>
    <ui-button
      *ngIf="tab === 'pricing'"
      type="primary"
      [label]="'settings.save' | translate | uppercase"
      icon="check_icon"
      iconPosition="start"
      (click)="save()">
    </ui-button>
  </ui-page-header>

  <div class="tabbar">
    <button class="tab" [class.active]="tab === 'pricing'" (click)="setTab('pricing')">
      {{ 'settings.orders_settings.tab_pricing' | translate }}
    </button>
    <button class="tab" [class.active]="tab === 'alerts'" (click)="setTab('alerts')">
      {{ 'common.alerts' | translate }}
    </button>
  </div>

  <div class="settings_scroll" *ngIf="tab === 'pricing'">
    <section class="pricing_section">
      <h2 class="section_title">{{ 'settings.orders_settings.default_price_source' | translate }}</h2>
      <p class="section_hint">
        <img src="assets/icones/info.svg" alt="" />
        <span>{{ 'settings.orders_settings.default_price_source_hint' | translate }}</span>
      </p>

      <div class="price_cards">
        <div
          *ngFor="let option of visiblePriceSourceOptions"
          class="price_card"
          [class.selected]="priceSource === option.value"
          (click)="selectPriceSource(option.value)"
          role="radio"
          [attr.aria-checked]="priceSource === option.value"
          tabindex="0"
          (keydown.enter)="selectPriceSource(option.value)"
          (keydown.space)="selectPriceSource(option.value)">
          <div class="price_card_header">
            <span class="radio" [class.checked]="priceSource === option.value"></span>
            <span class="price_card_title">
              {{ option.title | translate }}
              <span class="default_tag" *ngIf="option.isDefault">{{ 'settings.orders_settings.price_source.default_tag' | translate }}</span>
            </span>
          </div>
          <p class="price_card_description">{{ option.description | translate }}</p>
        </div>
      </div>

      <!-- One sentence per state, never two. The ordered list belongs to the
           Custom card; a preset card is summarised by the order it applies and
           the sources it leaves out; the inherited state — no card checked —
           says only that it inherits, because there is no tenant order to
           summarise and printing one would contradict the note above it. -->
      <p class="inherited_note" *ngIf="hasPricePolicy && priceSource === null">
        {{ 'settings.orders_settings.summary.inherited' | translate }}
      </p>
      <p class="order_summary" *ngIf="hasPricePolicy && priceSource !== 'custom' && priceSource !== null">
        {{ orderSummary }}
        <span class="summary_custom_hint">
          {{ 'settings.orders_settings.summary.custom_hint' | translate }}
        </span>
      </p>
      <app-price-sources-order
        *ngIf="hasPricePolicy && priceSource === 'custom'"
        [sources]="priceSources"
        [freshnessDays]="priceFreshnessDays"
        (changed)="onPriceSourcesChanged($event)">
      </app-price-sources-order>

      <!-- Only relevant when "No price by default" is the selected source, so it is
           its own full-width block below the cards rather than a disabled control
           tucked inside one of them. -->
      <div class="hide_columns" *ngIf="priceSource === 'none'">
        <div class="hide_columns_info">
          <span class="hide_columns_title">{{ 'settings.orders_settings.hide_pricing_columns' | translate }}</span>
          <p class="hide_columns_description">{{ 'settings.orders_settings.hide_pricing_columns_description' | translate }}</p>
        </div>
        <mat-slide-toggle
          [checked]="hidePricingColumns"
          (change)="onHidePricingColumnsChange($event.checked)"
          color="primary">
        </mat-slide-toggle>
      </div>
    </section>

    <!-- ── Order splitting rules ───────────────────────────────────────────── -->
    <section class="settings_section">
      <app-splitting-rules-list
        [rules]="splittingRules"
        [loading]="splittingRulesLoading"
        (addRule)="openRuleDrawer()"
        (edit)="openRuleDrawer($event)"
        (delete)="onDeleteRule($event)"
        (toggle)="onToggleRule($event)">
      </app-splitting-rules-list>
    </section>
  </div>

  <div class="settings_scroll" *ngIf="tab === 'alerts'">
    <section class="settings_section">
      <h2 class="section_title">{{ 'settings.orders_settings.alerts.title' | translate }}</h2>
      <p class="section_hint">
        <img src="assets/icones/info.svg" alt="" />
        <span>{{ 'settings.orders_settings.alerts.hint' | translate }}</span>
      </p>

      <div class="alert_row" *ngFor="let alertType of alertTypes">
        <span class="alert_row_title">{{ alertType.labelKey | translate }}</span>
        <mat-slide-toggle
          [checked]="isAlertEnabled(alertType.type)"
          (change)="onAlertToggle(alertType.type, $event.checked)"
          color="primary">
        </mat-slide-toggle>
      </div>
    </section>
  </div>
</div>

<!-- Drawer (outside page_container to avoid overflow clipping) -->
<app-splitting-rule-drawer
  [open]="drawerOpen"
  [rule]="selectedRule"
  [existingRules]="splittingRules"
  (save)="onSaveRule($event)"
  (closeDrawer)="drawerOpen = false">
</app-splitting-rule-drawer>
